import React from "react";
import style from "../../sass/skill.module.scss";
import Span from "../../helper/Span";
import { useSelector } from "react-redux";
import { AllSkillIcons, FrontendSkillIcons, BackendSkillIcons, ToolsSkillIcons, LanguageSkillIcons } from "../../helper/SkillIcons";
import SkillButtons from "./SkillButtons";
const Skill = () => {
     const { activeButton } = useSelector((state) => state.skill);
     return (
          <section className={style.skill}>
               <div className={style.skill_container}>
                    <div className={style.skill_content}>
                         <div className={style.skill_heading}>
                              My
                              <div className={style.skill_heading_technical}>
                                   {"Technical".split("").map((alphabet, index) => (
                                        <Span alp={alphabet} key={index} />
                                   ))}
                              </div>
                              Skills
                         </div>
                         <SkillButtons />
                         <div className={style.skill_list}>
                              {activeButton === "All" && <AllSkillIcons />}
                              {activeButton === "Language" && <LanguageSkillIcons />}
                              {activeButton === "Frontend" && <FrontendSkillIcons />}
                              {activeButton === "Backend" && <BackendSkillIcons />}
                              {activeButton === "Tools" && <ToolsSkillIcons />}
                         </div>
                    </div>
               </div>
          </section>
     );
};
export default Skill;
